export enum A48ReportPerms {
    ALL = 0,
    PERMS = 1,
    NO_PERMS = 2
}
